import { createRoute } from '@tanstack/react-router';
import { SharingControls } from '../components/sharing-controls.tsx';
import { Route as parent } from './site.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: 'sharing',
  component: RouteComponent,
});
function RouteComponent() {
  const { siteId } = Route.useParams();
  return <SharingControls target={{ siteId }} />;
}
